define('application/ApplicationRouter', [
    'application/models/ApplicationModel',
    'application/views/ApplicationView'
], function(ApplicationModel, ApplicationView) {

    var ApplicationRouter = Backbone.Router.extend({

        controller: null,

        segment: {
            popin: null
        },

        routes: {
            '': 'onBlank',
            '(popin)(/:id)': 'onRoute'
        },

        initialize: function(options) {
            this.config = options.config;
            this.viewmodel = new ApplicationModel();

            this.view = new ApplicationView({
                "viewmodel": this.viewmodel,
                "datas": options.datas,
                "config": options.config,
                "wording": options.wording,
                "router": {
                    setRoute: _.bind(this.setRoute, this),
                    getSegment: _.bind(function() {
                        return this.segment;
                    }, this)
                }
            });

            $(document).on('click', 'a[href^="#"]', _.bind(this.onNavigate, this));
        },

        onBlank: function(e) {
            if( this.config.queryString && this.config.queryString.link ) {
                var segment = this.getSegmentFromRoute( this.config.queryString.link );
                this.setRoute( segment );
            } else {
                // this.setRoute({"section": this.defaultSection });
            }
        },

        onNavigate: function(e) {
            e.preventDefault();

            if (e.currentTarget.hash === "") return;

            var segment = this.getSegmentFromRoute( e.currentTarget.hash.substr(1) );
            this.setRoute( segment );
        },

        getSegmentFromRoute: function( route ) {

            var hashArr = route.split('/');

            // Transform [key1, val1, key2, val2] into {key1: val1, key2: val2}
            var hashSegment = {};
            var i = 0, hashArrLength = hashArr.length;
            while (i < hashArrLength) {
                hashSegment[hashArr[i]] = hashArr[++i];
                i++;
            }

            return hashSegment;
        },

        getRouteFromSegment: function(segment) {
            var route = [];
            _.each(segment, function(value, key, list) {
                if (value) {
                    route.push(key);
                    route.push(value);
                }
            });
            return route.join('/');
        },

        setRoute: function(segment, silent) {
            // var currentURL = Backbone.history.getFragment(); // URL with popin fragment
            // var newURL = currentURL.replace(new RegExp(/\/?popin\/([\w]+)-([\w]+)/), ''); // erase popin fragment
            var newSegment = _.extend(_.clone(this.segment), segment);
            var newURL = this.getRouteFromSegment(newSegment);

            if (silent) {
                this.segment = newSegment;
            }

            if (newURL === "") {
                Backbone.history.navigate("#!", {
                    trigger: !silent
                });
            } else {
                Backbone.history.navigate(newURL, {
                    trigger: !silent
                });
            }
        },

        onRoute: function(popinId) {

            var newSegment = {
                popin: popinId
            };

            if (newSegment.popin && this.segment.popin !== newSegment.popin) {
                this.onPopin(popinId);
            } else if (!newSegment.popin && this.segment.popin) {
                this.onClosePopin(this.segment.popin);
            }

            this.segment = newSegment;

        },

        /*
         * Call when popinId change from the previous one
         */
        onPopin: function(popinId) {
            this.view.openPopin(popinId);
        },

        /*
         * Call when a popin was opened but it was delete from the route
         */
        onClosePopin: function(popinId) {
            this.view.closePopin(popinId);
        },

        onLoaderAnimationComplete: function() {
            this.view.onLoaderAnimationComplete();
        }
    });

    return ApplicationRouter;
});
